import axios from 'axios';
import * as Sentry from "@sentry/react";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  responseType: "json"
});


const loginToken = localStorage.getItem('loginToken');
if (loginToken) {
  API.defaults.headers.common['Authorization'] = loginToken;
}

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('loginToken');
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === "Network Error") {
      const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : null;

      if (error.response && error.response.status) {
        console.log("[Axios HTTP Error]", {
          status: error.response.status,
          statusText: error.response.statusText,
          url: error.config?.url,
          method: error.config?.method,
          data: error.response.data,
          navigatorOnline: isOnline
        });
      }
  
      if (error.message === "Network Error") {
        console.log("[Axios Network Error]", {
          message: error.message,
          config: {
            url: error.config?.url,
            method: error.config?.method,
            headers: error.config?.headers
          },
          code: error.code,
          isAxiosError: error.isAxiosError,
          toJSON: JSON.stringify(error.toJSON(), null, 2),
          navigatorOnline: isOnline
        });
        
        alert("Ocurrió un error. Por favor compruebe su conexión a internet y recargue la página. Si el problema persiste, reinicie su sesión.")
      }
    }

    return Promise.reject(error);
  }
);

export default API;